import {
  ErpCamposIntegracao,
  TipoProduto,
  SituacaoItemCompra,
} from 'px-business-components';
import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';

function isSituacaoValida(situacao) {
  return !situacao || situacao === SituacaoItemCompra.keys.ATIVO.key;
}

const hasCamposProdutoErpNeo = campoIntegracao => campoIntegracao.contaContabil !== null;

const hasCamposProdutoSankhyaNorsil = campoIntegracao => campoIntegracao.armazem !== null;

const hasCamposProdutoSankhyaArtLatex = campoIntegracao => campoIntegracao.armazem !== null;

const hasCamposProdutoErpTotvs = campoIntegracao => campoIntegracao.contaContabil !== null
  && campoIntegracao.armazem !== null;

const hasCamposProdutoErpTotvsProtheus = campoIntegracao => campoIntegracao.contaContabil !== null
  && campoIntegracao.contaFinanceira !== null;

const hasCamposProdutoErpM365BuscheLepper = campoIntegracao => campoIntegracao.segmento !== null;

const hasCamposProdutoErpSenior = campoIntegracao => campoIntegracao.armazem !== null;

const hasCamposProdutoErpCigam = campoIntegracao => campoIntegracao.contaContabil !== null
  && campoIntegracao.armazem !== null;

const hasCamposProdutoErpSeniorTeixeira = campoIntegracao => campoIntegracao.armazem !== null
  && campoIntegracao.contaContabil !== null && campoIntegracao.contaFinanceira !== null;

const hasCamposProdutoErpSeniorMedal = campoIntegracao => campoIntegracao.armazem !== null;

const hasCamposProdutoErpCrmSolucoes = campoIntegracao => campoIntegracao.contaDespesa !== null;

const hasCamposProdutoErpFocco = campoIntegracao => campoIntegracao.contaFinanceira !== null;

const hasCamposProdutoErpCasaShopping = campoIntegracao => campoIntegracao.contaDespesa !== null;

const hasCamposProdutoErpSeniorMega = campoIntegracao => campoIntegracao.operacao !== null
  && campoIntegracao.contaFinanceira !== null;

const hasCamposProdutoErpSapB1 = campoIntegracao => campoIntegracao.armazem !== null;

const hasCamposProdutoErpSeniorPfiffner = camposIntegracao => camposIntegracao.armazem !== null;

const hasCamposProdutoErpEliteSoft = campoIntegracao => campoIntegracao.contaFinanceira !== null;

export const hasCadastrosAdicionaisProdutoErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return hasCamposProdutoErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return hasCamposProdutoErpTotvsProtheus(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return hasCamposProdutoErpM365BuscheLepper(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return hasCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return hasCamposProdutoErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return hasCamposProdutoErpCigam(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return hasCamposProdutoErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return hasCamposProdutoErpSeniorMedal(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return hasCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return hasCamposProdutoErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return hasCamposProdutoErpCrmSolucoes(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return hasCamposProdutoErpFocco(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return hasCamposProdutoErpSeniorMega(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return hasCamposProdutoErpCasaShopping(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return hasCamposProdutoSankhyaNorsil(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return hasCamposProdutoSankhyaArtLatex(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return hasCamposProdutoErpSapB1(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return hasCamposProdutoErpSeniorPfiffner(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return hasCamposProdutoErpEliteSoft(camposIntegracao);
  }
  return false;
};

const validateCamposErpSeniorTeixeira = (camposIntegracao, produto) => {
  if (!camposIntegracao.armazem && produto.tipoProduto === TipoProduto.keys.PRODUTO.key) {
    return [false, 'Depósito é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSankhyaNorsil = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSankhyaArtLatex = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpCigam = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSeniorMedal = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpNeo = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpNeoG7 = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpCrmSolucoes = (camposIntegracao, type) => {
  if (!camposIntegracao.contaDespesa && type === 'COMPRA') {
    return [false, 'Conta de despesa é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpFocco = (camposIntegracao, type) => {
  if (!camposIntegracao.contaFinanceira && type === 'COMPRA') {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorMega = (camposIntegracao, type) => {
  if (!camposIntegracao.contaFinanceira && type === 'COMPRA') {
    return [false, 'Classe financeira é obrigatória'];
  }
  if (!camposIntegracao.operacao && type === 'COMPRA') {
    return [false, 'Operação é obrigatória'];
  }
  return [true, null];
};
const validateCamposErpCasaShopping = (camposIntegracao, type) => {
  if (!camposIntegracao.contaDespesa && type === 'COMPRA') {
    return [false, 'Conta é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSapB1 = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSeniorPfiffner = (camposIntegracao, produto) => {
  if (!camposIntegracao.armazem && produto.tipoProduto === TipoProduto.keys.PRODUTO.key) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpTotvsProtheus = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta é obrigatória'];
  }
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'Classe de valor é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpEliteSoft = (camposIntegracao, type) => {
  if (!camposIntegracao.contaFinanceira && type === 'COMPRA') {
    return [false, 'Conta é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpM365BuscheLepper = (camposIntegracao) => {
  if (!camposIntegracao.segmento) {
    return [false, 'Segmento é obrigatório'];
  }
  return [true, null];
};


export const validateCamposProdutoErp = (
  tipoErp,
  camposIntegracao,
  produto,
  situacaoItemCompra,
  type,
) => {
  if (!isSituacaoValida(situacaoItemCompra)) {
    return [true, null];
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return validateCamposErpNeo(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return validateCamposErpCigam(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return validateCamposErpSeniorTeixeira(camposIntegracao, produto);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return validateCamposErpSeniorMedal(camposIntegracao, produto);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return validateCamposErpNeoG7(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return validateCamposErpCrmSolucoes(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return validateCamposErpFocco(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return validateCamposErpSeniorMega(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return validateCamposErpCasaShopping(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return validateCamposErpSankhyaNorsil(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return validateCamposErpSankhyaArtLatex(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return validateCamposErpSapB1(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return validateCamposErpSeniorPfiffner(camposIntegracao, produto);
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return validateCamposErpTotvsProtheus(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return validateCamposErpEliteSoft(camposIntegracao, type);
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return validateCamposErpM365BuscheLepper(camposIntegracao);
  }
  return [true, null];
};

export const computeFromProduto = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return {
      operacao: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.OPERACAO.key),
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CONDOR.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return {
      armazem: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.ARMAZEM.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return {
      segmento: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.SEGMENTO.key),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposProdutoErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      armazem: null,
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return {
      armazem: null,
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      armazem: null,
      contaContabil: null,
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_G7.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return {
      contaDespesa: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return {
      operacao: null,
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CONDOR.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return {
      armazem: null,
      contaContabil: null,
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return {
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return {
      segmento: null,
      contaContabil: null,
    };
  }
  return {};
};
